module.exports = __webpack_public_path__ + "img/valve-12-34-56.52cc125a.svg";